import { ImageNowClient, ImageNowCommandDTO } from 'business/models/Models';
import ModelFactory from 'business/models/ModelFactory';
import BaseService from './BaseService';

export default class ImageNowService extends BaseService {
  async ImageNow(
    imagingLevel: string,
    imagingSubLevels: string[],
    captureProfileIds: number[],
    experimentIds: number[],
    plateIds: number[],
    selectedDropIds: number[],
    selectedRegionName: string,
  ) {
    const imageNowClient: ImageNowClient = ModelFactory(ImageNowClient, false, true);
    const imageNowRequestDetails: ImageNowCommandDTO = new ImageNowCommandDTO();

    imageNowRequestDetails.imagingLevel = imagingLevel;
    imageNowRequestDetails.imagingSubLevels = imagingSubLevels;
    imageNowRequestDetails.captureProfileIds = captureProfileIds;
    imageNowRequestDetails.selectedExperimentIds = experimentIds;
    imageNowRequestDetails.selectedPlateIds = plateIds;
    imageNowRequestDetails.selectedDropIds = selectedDropIds;
    imageNowRequestDetails.selectedRegionName = selectedRegionName;

    return await imageNowClient.setImageNow(imageNowRequestDetails);
  }
}
